import { atom, useAtom } from "jotai";

import { useDesignLabConfig } from "@design-lab/shared/lib/config";

const TOTAL_CREDITS = 5;

export const aiCreditsBalanceAtom = atom<number | undefined>(undefined);

export type TokenManagement = {
  totalCredits: number;
  aiCreditsBalance: number;
  updateAiCreditsBalance: (newBalance: number) => void;
};

export function useTokenManagement(): TokenManagement {
  const [storedBalance, setAiCreditsBalance] = useAtom(aiCreditsBalanceAtom);
  const config = useDesignLabConfig();

  // Use stored balance if available, otherwise use config value, otherwise default to 0
  const aiCreditsBalance = storedBalance ?? config.aiCreditsBalance ?? 0;

  const updateAiCreditsBalance = (newBalance: number) => {
    setAiCreditsBalance(newBalance);
  };

  return {
    totalCredits: TOTAL_CREDITS,
    aiCreditsBalance,
    updateAiCreditsBalance
  };
}
